import type { ContextualizedError } from '#app/lib/error'
import { reportError } from '#app/lib/reports'

export default () => {
  // Override window.onerror to always log the stacktrace
  window.onerror = function (errorMsg, url, lineNumber, columnNumber, errObj: ContextualizedError) {
    if (errObj == null) {
      // Prevent error report to crash because a browser doesn't follow this convention
      // (or is that standard?)
      errObj = {
        name: 'nullishUnhandledError',
        message: errorMsg?.toString?.(),
        context: Array.from(arguments),
        stack: '',
      }
    } else if (typeof errorMsg === 'string' && errorMsg.startsWith('ResizeObserver loop completed with undelivered notifications')) {
      // Probably caused by Masonry call to ResizeObserver. Can be ignored, see https://stackoverflow.com/a/77591424
      return
    }

    console.error(errObj, errObj.context)

    // Avoid using utils that might not have been defined yet
    const args = [].slice.call(arguments, 0)

    if (args?.[4] != null) {
      const {
        name,
      } = args[4]

      if (name === 'InvalidStateError') {
        // Already handled at feature_detection, no need to let it throw
        // and report to server
        console.warn('InvalidStateError: no worries, already handled')
      } else if (name === 'ViewDestroyedError') {
        // ViewDestroyedError are anoying but not critical: debugged from development
        // but not worth the noise in production logs
        console.warn('ViewDestroyedError: not reported')
      }
    }

    reportError(errObj)
  }
}
